<template>
    <div class="expansion-panel" :style="{'--border-radius': borderRadius + 'px'}">
        <div 
            class="expansion-panel-header"
            v-bind:data-expanded="isExpanded"
            @click="toggleExpanded"
        >
            <slot name="header"></slot>
            <ArrowDownSvg class="expansion-panel-chevron" :class="{ 'expanded': isExpanded }"/>
        </div>
        <Transition name="expand">
            <div 
                v-if="isExpanded"
                class="expansion-panel-content"
            >
                <slot name="content"></slot>
            </div>
        </Transition>
    </div>
</template>

<script>

import ArrowDownSvg from '@/assets/icons/arrow-down.svg';

export default {
    name: 'expansionPanelUI',
    components: {
        ArrowDownSvg
    },
    props: {
        expanded: {
            type: Boolean,
            default: false
        },
        borderRadius: {
            type: String,
            default: '12'
        }
    },
    data() {
        return {
            isExpanded: this.expanded
        }
    },

    watch: {
        expanded(newVal) {
            this.isExpanded = newVal;
        }
    },

    methods: {
        toggleExpanded() {
            this.isExpanded = !this.isExpanded;
            this.$emit('onExpandedChange', this.isExpanded);
        }
    }
}
</script>

<style scoped>
.expansion-panel {
    width: 100%;
}

.expansion-panel-header {
    display: flex;
    align-items: center;
    padding: var(--spacing);
    background: var(--background-white);
    border: 1px solid var(--border-primary);
    border-radius: var(--border-radius);
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s ease;
}

.expansion-panel-header[data-expanded="true"] {
    border-radius: var(--border-radius) var(--border-radius) 0 0;
}

.expansion-panel-header:hover {
    background-color: var(--background-gray);
}

.expansion-panel-chevron {
    transition: transform 0.3s ease;
    flex-shrink: 0;
}

.expansion-panel-chevron:hover {
    opacity: 0.7;
}

.expansion-panel-chevron.expanded {
    transform: scaleY(-1);
}

.expansion-panel-content {
    padding: var(--spacing);
    background: var(--background-white);
    border: 1px solid var(--border-primary);
    border-top: none;
    border-radius: 0 0 var(--border-radius) var(--border-radius);
    margin-top: -2px;
}

.expand-enter-active,
.expand-leave-active {
    transition: max-height 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
    max-height: 0;
    opacity: 0;
}

.expand-enter-to,
.expand-leave-from {
    max-height: 1000px;
    opacity: 1;
}
</style>